import React, { useEffect, useState } from "react";
import { CsvBuilder } from "filefy";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LoadingSkeleton from "../BasicTable/LoadingSkeleton";
import "../BasicTable/TableStyles.css";
import { headings } from "../BasicTable/Columns";

const createRow = (item, key) => {
  let row = [];
  row.push((100001 + key).toString());
  row.push(item?.restaurantName);
  row.push(item?.restaurantType);
  row.push(item["$Due"]);
  row.push(item?.restaurantAddress);
  row.push(item?.createdAt);
  row.push("Static");
  row.push("Static");
  row.push(item?.restaurantOwner);
  row.push(item?.restaurantPhone.toString());
  row.push("Static");
  return row;
};

const SortedTable = ({
  restaurants,
  exp,
  setExp,
  order,
  page,
  rowsPerPage,
  setOrder,
  setPage,
  setRowsPerPage,
}) => {
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  let data = [];
  function convertTime(time) {
    var t = time.substring(0, 10);
    return t;
  }

  const createTable = () => {
    data = [];
    restaurants.forEach((item, key) => {
      data.push(createRow(item, key));
    });
    return data;
  };

  const createCsv = () => {
    const currTime = new Date();
    const builder = new CsvBuilder(currTime.toISOString() + ".csv");
    builder
      .setDelimeter(",")
      .setColumns(headings)
      .addRows(createTable())
      .exportFile();
  };

  const compare = (a, b) => {
    var x = a["$Due"];
    var y = b["$Due"];
    let value = x < y ? -1 : x > y ? 1 : 0;
    return order === "desc" ? value : -value;
  };

  const sortArray = () => {
    restaurants.sort((a, b) => compare(a, b));
    setOrder((prev) => (prev === "desc" ? "asc" : "desc"));
  };

  useEffect(() => {
    if (exp === true) {
      createCsv();
      setExp(false);
    }
  }, [exp]);

  return (
    <>
      <TableContainer component={Paper}>
        {restaurants.length === 0 ? (
          <LoadingSkeleton />
        ) : (
          <Table
            sx={{ minWidth: 660 }}
            size="small"
            aria-label="a dense table"
            className="table"
          >
            <TableHead>
              <TableRow style={{ backgroundColor: "#f3f7f7" }}>
                {headings.map((heading, index) =>
                  heading != "$Due" ? (
                    <TableCell key={index}>{heading}</TableCell>
                  ) : (
                    <TableCell key={index}>
                      <TableSortLabel onClick={sortArray} direction={order}>
                        <span>{heading}</span>
                      </TableSortLabel>
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody className="table-body">
              {restaurants
                .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    style={{ fontSize: "1px" }}
                  >
                    <TableCell component="td" scope="row">
                      {100000 + index + 1}
                    </TableCell>
                    <TableCell>
                      <Link to={`/restaurants/${row._id}`}>
                        {row?.restaurantName}
                      </Link>
                    </TableCell>
                    <TableCell>{row?.restaurantType}</TableCell>
                    <TableCell>{row["$Due"]}</TableCell>
                    <TableCell>{row?.restaurantAddress}</TableCell>
                    <TableCell>{convertTime(row.createdAt)}</TableCell>
                    <TableCell>Static</TableCell>
                    <TableCell>Static</TableCell>
                    <TableCell>{row?.restaurantOwner}</TableCell>
                    <TableCell>{row?.restaurantPhone}</TableCell>
                    <TableCell>Static</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={restaurants.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default SortedTable;
